import { getRequest, postRequest,urlTitle } from "@/utils/request";
import qs from "qs";
window.qs = qs;
// 巡检项管理
export const inspectionItemApi = {
  // 巡检项分类
  queryInspectionType: () => {
    return getRequest(`${urlTitle}/operation/inspection/list`);
  },
  // 巡检项分类
  updateInspectionType: (params) => {
    return postRequest(`${urlTitle}/operation/inspection/update`, params);
  },
  // 巡检项分类
  createInspectionType: (params) => {
    return postRequest(`${urlTitle}/operation/inspection/add`, params);
  },
  // 删除巡检项
  deleteInspectionType: (id) => {
    return postRequest(`${urlTitle}/operation/inspection/${id}`);
  },
  // 巡检项列表
  queryInspectionItem: (params) => {
    return getRequest(`${urlTitle}/operation/inspection/item/page/list`, params);
  },
  // 创建巡检项
  createInspectionItem: (params) => {
    return postRequest(`${urlTitle}/operation/inspection/item/add`, params);
  },
  // 修改巡检项
  updateInspectionItem: (params) => {
    return postRequest(`${urlTitle}/operation/inspection/item/update`, params);
  },
  // 删除巡检项
  deleteInspectionItem: (id) => {
    return postRequest(`${urlTitle}/operation/inspection/item/${id}`);
  },
};
